import { API_URL } from "../../../../../../constants";
import * as httpNetworking from "../../../../../../httpNetworking";

const VERSION = 0;

export async function getMAUForMultiTenancyApp(data: {
    deploymentId: string;
    deploymentType: "development" | "production";
    appId: string;
    days: Number;
}): Promise<{
    count: number;
}> {
    const { deploymentId, deploymentType, appId, days } = data;

    const options: httpNetworking.GETRequestConfig = {
        params: {
            deploymentId,
            deploymentType,
            days
        }
    };

    const url = `${API_URL}/saas/multi-tenancy/connection-uri-domain/${appId}/users/count/active`;

    const result = await httpNetworking.simpleGETRequest(url, options, VERSION);
    return result.data;
}
